import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';

const ColorPicker = ({ onColorSelect, value }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedColor, setSelectedColor] = useState('#FF0000');

  const colorSets = [
    {
      name: 'Red',
      shades: ['#FF0000']
    },
    {
      name: 'Orange',
      shades: ['#FFA500']
    },
    {
      name: 'Green',
      shades: ['#00FF00']
    }
  ];

  const handleColorSelect = (color) => {
    setSelectedColor(color);
    onColorSelect?.(color);
    setIsOpen(false);
  };

  useEffect(() => {
    if(value) {
      setSelectedColor(value)
    }
  })

  return (
    <div className="position-relative d-inline-block mt-3">
      {/* Color picker button */}
      <button
        type='button'
        className="d-flex align-items-center gap-2 p-2 border rounded btn btn-light"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div 
          className="border"
          style={{ width: '24px', height: '24px', backgroundColor: selectedColor }}
        />
        <span className="dropdown-toggle-split ms-1">
          <FontAwesomeIcon icon={faCaretDown} />
        </span>
      </button>

      {/* Dropdown panel */}
      {isOpen && (
        <div className="position-absolute mt-1 p-2 bg-white border rounded shadow" 
             style={{ zIndex: 1000 }}>
          <div className="d-flex gap-2">
            {colorSets.map((colorSet) => (
              <div key={colorSet.name} className="d-flex flex-column gap-1">
                <div className="small text-muted text-center mb-1">
                  &nbsp;
                </div>
                {colorSet.shades.map((shade, index) => (
                  <button
                    key={`${colorSet.name}-${index}`}
                    className="border p-0"
                    style={{ 
                      width: '32px', 
                      height: '32px', 
                      backgroundColor: shade,
                      cursor: 'pointer'
                    }}
                    onClick={() => handleColorSelect(shade)}
                    title={`${colorSet.name} Shade ${index + 1}`}
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorPicker;